import { create } from 'zustand';

type UseFurtherInformationState = {
  hasToDisplayContainsEmptyPackagesAlertMessage: boolean;
  hasToDisplayRequiresSpsFormalitiesAlertMessage: boolean;
  isChedCustomsDocumentUploaded: boolean;
  isEadCustomsDocumentUploaded: boolean;
  setHasToDisplayContainsEmptyPackagesFurtherInformation: (
    hasToDisplayContainsEmptyPackagesAlertMessage: boolean,
  ) => void;
  setHasToDisplayRequiresSpsFormalitiesFurtherInformation: (
    hasToDisplayRequiresSpsFormalitiesAlertMessage: boolean,
  ) => void;
};

export const useFurtherInformationState = create<UseFurtherInformationState>((set) => ({
  hasToDisplayContainsEmptyPackagesAlertMessage: false,
  hasToDisplayRequiresSpsFormalitiesAlertMessage: false,
  isChedCustomsDocumentUploaded: false,
  isEadCustomsDocumentUploaded: false,
  setHasToDisplayContainsEmptyPackagesFurtherInformation: (hasToDisplayContainsEmptyPackagesAlertMessage: boolean) =>
    set(() => ({ hasToDisplayContainsEmptyPackagesAlertMessage })),
  setHasToDisplayRequiresSpsFormalitiesFurtherInformation: (hasToDisplayRequiresSpsFormalitiesAlertMessage: boolean) =>
    set(() => ({ hasToDisplayRequiresSpsFormalitiesAlertMessage })),
}));
